import 'core-js/es/typed-array/last-index-of';
import 'core-js/es/typed-array/slice';
import StreamFileReader from './StreamFileReader';
import { decodeStream } from './Iconv';

export function readFileAsText(inputFile: File|Blob): Promise<string> {
  return streamDecodeToString(new StreamFileReader(inputFile));
}

export function streamDecodeToString(source: NodeJS.ReadableStream): Promise<string> {
  return new Promise((resolve, reject) => {
    let result = '';
    const stream = source.pipe(decodeStream('cp932'));
    stream.on('data', (string: string) => { result += string });
    stream.on('error', (err: Error) => { reject(Error) });
    stream.on('end', () => { resolve(result) });
  });
}
